import { EnrollTransactionTypeEnum } from './enroll-transaction-type-enum.generated';

const x: { [index: string]: string } = {};
x[EnrollTransactionTypeEnum.Unknown] = 'Unknown';
x[EnrollTransactionTypeEnum.OpenPlan] = 'Open Plan';
x[EnrollTransactionTypeEnum.NewHire] = 'New Hire';
x[EnrollTransactionTypeEnum.LifeEvent] = 'Life Event';
x[EnrollTransactionTypeEnum.OpenEnrollment] = 'Open Enrollment';
x[EnrollTransactionTypeEnum.BeneficiaryChange] = 'Beneficiary Change';
x[EnrollTransactionTypeEnum.ChangeInEmploymentStatus] = 'Change In Employment Status';
x[EnrollTransactionTypeEnum.ReturnFromLeave] = 'Return From Leave';
x[EnrollTransactionTypeEnum.PerpetualEnrollment] = 'Perpetual Enrollment';
x[EnrollTransactionTypeEnum.DependentAudit] = 'Dependent Audit';
x[EnrollTransactionTypeEnum.LateEntrantOpenEnrollment] = 'Late Entrant Open Enrollment';
x[EnrollTransactionTypeEnum.EnrollmentMessage] = 'Enrollment Message';
x[EnrollTransactionTypeEnum.Acquisition] = 'Acquisition';
x[EnrollTransactionTypeEnum.NetworkChange] = 'Network Change';
export const EnrollTransactionTypeEnumDescriptions: { [indexer: string]: string } = x;
